import { CodesVersion } from "./enum/codesVersionEnum"

export const currentCodeVersion = CodesVersion.VERSION_1_8

export const ICADE_SIRET = "58207494401211"
export const TTB_SIRET = "92170493800015"
export const NONE_OPTION_LABEL = "Aucun(e)"

export const pagesUrl = {
  // MACRO MAKER (US 2566) — the URL holds none of "/beem-shot", "/rsee", "/project": the side bar reads them first
  MACRO_MAKER_PAGE: "/macro-maker",

  // GAMMES
  MY_GAMMES_PAGE: "/mes-gammes",
  MY_GAMMES_DETAIL_PAGE: "/mes-gammes/:gammeId",

  // INIES CHANGES (US 2620) — not under "/inies": the dev server sends that path to the API
  INIES_CHANGES_PAGE: "/modifications-inies",

  // GLOBAL
  SIGN_IN_PAGE: "/signin",
  SIGN_UP_INVITATION_PAGE: "/signup/:invitationId/user",
  REFERRAL: "https://timetobeem.com/formulaire-parrainage/",
  FORGOT_PWD_PAGE: "/password",
  CONFIRM_PAGE: "/confirm",
  ACCOUNT_PAGE: "/my-account",
  MY_OFFER_PAGE: "/my-offer",
  MY_ORGANIZATION_PAGE: "/my-organization",
  MY_ORGANIZATION_EDIT_USER_PAGE: "/my-organization/user/:userId",
  MY_MATERIAL_PAGE: "/material-lib",
  HOME: "/home",
  GLOBAL_RSEE_DASHBOARD: "/global-rsee-dashboard",
  OPEE_ANALYSIS: "/opee-analysis",

  // Projets
  PROJECTS_PAGE: "/projects",
  PROJECT_PAGE_DETAIL: "/project/:projectId",
  BIM_MODEL_IMPORT_PAGE: "/project/:projectId/bim-model/:bsBimModelId/import", //For new model: bsBimModelId == "new"
  BIM_MODEL_DETAIL_PAGE: "/project/:projectId/bim-model/:bsBimModelId/detail",
  CONTROL_BOARD_HOME: "/control-board-home",

  // QUANTI
  // The param is quantiVariantId, NOT bsVariantId: BSVariantContext destructures bsVariantId from
  // useParams globally, and reusing the name would have it resolve a Quanti id against the Beem Shot
  // list. Undefined is what we want there — it clears the selection instead of leaving a stale variant.
  // The path also stays clear of "/beem-shot", which getUrlState matches on to decide the navbar identity.
  QUANTI_VARIANT_DETAILS: "/project/:projectId/quanti/variant/:quantiVariantId/detail",

  // BEEM SHOT
  VARIANT_DETAILS: "/project/:projectId/beem-shot/variant/:bsVariantId/detail",
  BUILDING_CHOICE: "/project/:projectId/beem-shot/variant/:bsVariantId/detail/building/:bsBuildingId/choice",
  BUILDING_ZONE: "/project/:projectId/beem-shot/variant/:bsVariantId/detail/building/:bsBuildingId/zone",
  BUILDING_LEVEL: "/project/:projectId/beem-shot/variant/:bsVariantId/detail/building/:bsBuildingId/level",
  CALCUL:
    "/project/:projectId/beem-shot/variant/:bsVariantId/building/:bsBuildingId/bim-model/:bsBimModelId/zone/:bsZoneId/calcul",
  CALCUL_MORPHOLOGY: "/project/:projectId/beem-shot/variant/:bsVariantId/building/:bsBuildingId/zone/:bsZoneId/calcul",
  BUILDING_PARKING: "/project/:projectId/beem-shot/variant/:bsVariantId/detail/building/:bsBuildingId/parkings",
  BUILDING_PATIO: "/project/:projectId/beem-shot/variant/:bsVariantId/detail/building/:bsBuildingId/patios",
  BUILDING_FONDATION: "/project/:projectId/beem-shot/variant/:bsVariantId/detail/building/:bsBuildingId/fondations",
  BUILDING_REPARTITION: "/project/:projectId/beem-shot/variant/:bsVariantId/detail/building/:bsBuildingId/repartition",

  //BEEM SHOT
  /** @deprecated **/
  BEEM_SHOT_HOME: "/beem-shot",
  BEEM_SHOT_CHANTIER: "/project/:projectId/beem-shot/variant/:bsVariantId/building/:bsBuildingId/zone/:bsZoneId/chantier",
  BEEM_SHOT_HELP_CENTER: "/help-center",
  HELP_CENTER_TUTORIAL_CHAPTER: "/help-center/tutorial/:chapterId",
  BEEM_SHOT_CONFIGURATION_HELPER: "/beem-shot/configuration-helper",
  BEEM_SHOT_TUTORIAL_HELPER: "/beem-shot/tutorial-helper",

  KAIRNIAL_DASHBOARD: "/kairnial-dashboard",

  // Beem pilot
  BEEM_PILOT_UPLOAD_PAGE: "/project/:projectId/rsee/document/:rseeDocumentId/upload-file",
  BEEM_PILOT_DOCUMENT_DETAIL_PAGE: "/project/:projectId/rsee/document/:rseeDocumentId/detail",
  BEEM_PILOT_DASHBOARD_EXTERNAL: "/beem-pilot/rsee/external",
  // US 2580 — the dashboard of a Beem Shot variant opened by a share link, without an account
  BEEM_SHOT_DASHBOARD_EXTERNAL: "/beem-shot/external",
}

export const adminPagesUrl = {
  ADMIN_USER_ORGANIZATION_PAGE: "/admin/organization/:organizationId/user",
  ADMIN: "/admin",
  ADMIN_ORGANIZATION_LIST_PAGE: "/admin/organization-list",
  ADMIN_SUMMARY: "/admin/summary",
  ADMIN_ORGANIZATION_PAGE: "/admin/organization/:organizationId",
  ADMIN_ORGANIZATION_AGENCIES_PAGE: "/admin/organization/:organizationId/agencies",
  ADMIN_ORGANIZATION_USER_PAGE: "/admin/organization/:organizationId/user/:userId",
  ADMIN_ORGANIZATION_INVITE_USER_PAGE: "/admin/organization/:organizationId/admin-invite-user",
  ADMIN_EXPORT_PAGE: "/admin/exports",
  ADMIN_JOBS_PAGE: "/admin/jobs",
  ADMIN_MACRO_MAKER_PAGE: "/admin/macro-maker",
  ADMIN_OPEE_PAGE: "/admin/opee",
}

export const appConstants = {
  apiEndpoints: {
    // GLOBAL
    NOTIFICATION: "/notification",
    NOTIFICATION_SUBSCRIBE: "/notification/subscribe",
    NOTIFICATION_READ: "/notification/read",
    NOTIFICATION_READ_ALL: "/notification/read-all",
    MCP_ACCESS_TOKEN: "/user/mcp-access-token",
    CODE_ACV: "/code-acv",
    CODE_ACV_LOT: "/code-acv/lot",
    CODE_ACV_SOUS_LOT: "/code-acv/sous-lot",
    BEEM_GUIDE_EXCEL: "/require-beem-guide-access",

    //ProjectController
    PROJECT: "/project",
    PROJECT_PUBLIC: "/project/project-public",
    PROJECT_STATUS: "/project/status",
    USER_PROJECT_CARDS: "/project/project-cards-by-user",
    ORGANIZATION_PROJECT_CARDS: "/project/project-cards-by-organization",
    PROJECT_CARD_IMAGE: "/project/coverImage",
    COUNT_BEEM_PILOT_DOCUMENT: "/project/count-rsee-documents",
    COUNT_BEEM_SHOT_VARIANT: "/project/count-variants",
    COUNT_BIM_MODEL: "/project/count-bim-model",
    /** US 2648 — every document deposited in the modules of a project, for its « Documents » tab. */
    PROJECT_DOCUMENT_LIST: "/project/document-list",
    COUNT_PROJECT: "/project/projects-count",
    PROJECT_COVER_IMAGE: "/project/coverImage",

    //TeamController
    TEAM: "/project/team",
    TEAM_COUNT: "/project/team/count",

    //MaterialController
    ORGANIZATION: "/organization",
    /** Logo printed on the ACV report; upload and removal are administrator-only (US 2370). */
    ORGANIZATION_LOGO: "/organization/my-organization/logo",
    ORGANIZATION_TEAM_ADMIN_COLLABORATORS: "/organization/admin/collaborator/list",
    ORGANIZATION_TEAM_COLLABORATORS: "/organization/collaborator/collaborators-list",
    /** US 2596 — the collaborators the caller administers, for "Mon organisation > Collaborateurs" only. */
    ORGANIZATION_ADMINISTERED_COLLABORATORS: "/organization/collaborator/administered-list",
    /** US 2593 — French public company register, to prefill the admin organization form. */
    ORGANIZATION_COMPANY_SEARCH: "/organization/admin/company-search",
    HOME_LAST_PROJECTS: "/home-page/last-projects",

    //RseeController
    RSEE_DOCUMENT_LIST_GLOBAL_DASHBOARD: "/rsee/document-list-global-dashboard",
    RSEE_GLOBAL_DASHBOARD_DATA: "/rsee/global-dashboard-data",
    RSEE_GLOBAL_DASHBOARD_REPORTING: "/rsee/global-dashboard-reporting",

    // OPEE (observatoire RE2020, open data data.gouv.fr)
    OPEE_OBSERVATORY_FILTER_OPTIONS: "/opee/observatory/filter-options",
    OPEE_OBSERVATORY_OVERVIEW: "/opee/observatory/overview",
    OPEE_OBSERVATORY_MEAN_IC_CONSTRUCTION_BY_USAGE: "/opee/observatory/mean-ic-construction-by-usage",
    OPEE_OBSERVATORY_LOT_IMPACTS_BY_USAGE: "/opee/observatory/lot-impacts-by-usage",
    OPEE_OBSERVATORY_PERFORMANCE: "/opee/observatory/performance",
    OPEE_OBSERVATORY_LOTS: "/opee/observatory/lots",
    OPEE_OBSERVATORY_SOUS_LOTS: "/opee/observatory/sous-lots",
    OPEE_SYNCHRONIZATION_LAST: "/opee/synchronization/last",
    OPEE_SYNCHRONIZE: "/opee/synchronize",
    RSEE_DOCUMENT_CARDS_LIST: "/rsee/document-card-information",
    RSEE_DOCUMENT_COUNT: "/rsee/document-count",
    RSEE_DOCUMENT: "/rsee/document",
    RSEE_DOCUMENT_FILE: "/rsee/document/file",
    RSEE_REFERENCE_DOCUMENT_BUILDINGS: "/rsee/reference-documents/buildings",
    RSEE_REFERENCE_DOCUMENT_LOT_STATISTICS: "/rsee/reference-documents/lot-statistics",
    RSEE_UPDATE_REFERENCE_DOCUMENT: "/rsee/document/reference",
    RSEE_SHARE_LINK: "/rsee/share-link",
    RSEE_SHARE_LINK_ID: "/rsee/share-link/:shareLinkId",
    RSEE_DOCUMENT_LINK_LIST: "/rsee/share-link/share-link-list-by-document",
    // US 2580 — the share links of a Beem Shot variant, and what its public dashboard reads through the token
    BS_VARIANT_SHARE_LINK: "/rsee/share-link/bs-variant",
    BS_VARIANT_LINK_LIST: "/rsee/share-link/share-link-list-by-bs-variant",
    BS_VARIANT_PUBLIC: "/beem-shot/variant/variant-public",
    BS_BUILDING_LIST_PUBLIC: "/beem-shot/building/list-public",
    BS_ZONE_LIST_PUBLIC: "/beem-shot/zone/list-public",
    BS_ESTIMATION_RESULT_PUBLIC: "/beem-shot/comenv/result-public",
    BS_MATERIAL_RESULT_LIST_PUBLIC: "/beem-shot/material/material-result-public",
    BS_CERTIFICATION_BUILDING_RESULT_PUBLIC: "/beem-shot/certification/certification-result-public",
    BS_CERTIFICATION_PARCELLE_RESULT_PUBLIC: "/beem-shot/certification/parcelle-result-public",
    BS_SHARE_LINK_SETTINGS_PUBLIC: "/rsee/share-link/bs-settings-public",
    BS_SHARE_LINK_BUILDING_VIEW_PUBLIC: "/rsee/share-link/bs-building-view-public",
    INIES_RECORD_PUBLIC: "/inies/record-public",
    BEEM_SHOT_FICHE_CONFIGUREE_BY_OBJECT_ID_PUBLIC: "/beem-shot/fiche-configuree/by-object-id-public",
    RSEE_RESULT_LIST: "/rsee/rsee-result/rsee-result-list",
    RSEE_INPUT_LIST: "/rsee/rsee-input/rsee-input-list",
    RSEE_RSET_OUTPUT_LIST: "/rsee/rsee-rset-output/rsee-rset-output-list",
    RSEE_CEP_ANNUAL_LIST: "/rsee/rsee-cep-annual/rsee-cep-annual-list",
    RSEE_BE_LIST: "/rsee/rsee-be/rsee-be-list",
    RSEE_LOGICIEL_LIST: "/rsee/rsee-logiciel/rsee-logiciel-list",
    RSEE_OUTPUT_LIST: "/rsee/rsee-output/rsee-output-list",
    RSEE_RSET_PAROI_VITREE_LIST: "/rsee/rsee-rset-paroi-vitree/rsee-rset-paroi-vitree-list",
    RSEE_PILOT_COMENV_RESULT: "/rsee/:rseeDocumentId/pilot/result",
    RSEE_PILOT_COMENV_STATUS: "/rsee/:rseeDocumentId/pilot/status",
    RSEE_PILOT_COMENV_BASELINE: "/rsee/:rseeDocumentId/pilot/baseline",
    RSEE_PILOT_COMENV_RESULT_PUBLIC: "/rsee/pilot/result-public",
    RSEE_PILOT_COMENV_BASELINE_PUBLIC: "/rsee/pilot/baseline-public",
    RSEE_DOCUMENT_PUBLIC: "/rsee/document-public",
    RSEE_RESULT_LIST_PUBLIC: "/rsee/rsee-result/rsee-result-list-public",
    RSEE_INPUT_LIST_PUBLIC: "/rsee/rsee-input/rsee-input-list-public",
    RSEE_RSET_OUTPUT_LIST_PUBLIC: "/rsee/rsee-rset-output/rsee-rset-output-list-public",
    RSEE_CEP_ANNUAL_LIST_PUBLIC: "/rsee/rsee-cep-annual/rsee-cep-annual-list-public",
    RSEE_BE_LIST_PUBLIC: "/rsee/rsee-be/rsee-be-list-public",
    RSEE_LOGICIEL_LIST_PUBLIC: "/rsee/rsee-logiciel/rsee-logiciel-list-public",
    RSEE_OUTPUT_LIST_PUBLIC: "/rsee/rsee-output/rsee-output-list-public",
    RSEE_RSET_PAROI_VITREE_LIST_PUBLIC: "/rsee/rsee-rset-paroi-vitree/rsee-rset-paroi-vitree-list-public",

    RSEE_ADD_DOCUMENT: "/rsee/project/add-document",
    RSEE_SUMMARY_IMPORT_LIST: "/rsee/summary-import",
    RSEE_CONTROL_REPORT: "/rsee/control-report",
    RSEE_CHECKLIST_OVERRIDE_LIST: "/rsee/checklist-override-list",
    RSEE_CHECKLIST_OVERRIDE: "/rsee/checklist-override",
    RSEE_GAMME_ASSIGNMENT_LIST: "/rsee/gamme-assignment-list",
    RSEE_GAMME_ASSIGNMENT: "/rsee/gamme-assignment",
    RSEE_REFERENCE_SELECTION_LIST: "/rsee/reference-selection-list",
    RSEE_REFERENCE_SELECTION: "/rsee/reference-selection",
    RSEE_UPDATE_DOCUMENT_META: "/rsee/document/metadata",
    RSEE_ENV_REPORT: "/rsee/document/report/environnement",
    RSEE_OVERRIDE_INPUT: "/rsee/customization/override-input",
    RSEE_INPUT_TOGGLE_ENABLED: "/rsee/customization/override-input/toggle-enabled",
    RSEE_OVERRIDE_INPUT_LIST: "/rsee/customization/override-input-list",
    RSEE_CUSTOM_INPUT: "/rsee/customization/custom-input",
    RSEE_CUSTOM_INPUT_LIST: "/rsee/customization/custom-input-list",
    SNOWFLAKE_DUMP: "/snowflake/dump",
    RSEE_IS_DOCUMENT_OVERRIDDEN: "/rsee/customization/is-overridden",

    // Inies
    INIES: "/inies",
    INIES_RECORD: "/inies/record",
    INIES_RECORD_SUMMARY_LIST: "/inies/record-summary-list",
    INIES_ORGANISM_LIST: "/inies/organism/organism-list",
    INIES_NOMENCLATURE_FILTERS: "/inies/get-nomenclature-filters",
    INIES_RECORDS_FILTERS_PAGINATED: "/inies/inies-records-filtered-paginated",
    INIES_RECORDS_FILTERED_COUNT: "/inies/inies-records-filtered-count",
    INIES_FUNCTIONAL_UNITS: "/inies/functional-units",
    INIES_COMMERCIAL_REFERENCES: "/inies/commercial-references",
    INIES_DECLARATION_TYPE: "/inies/declaration-types",
    INIES_RECENT_CHANGES: "/inies/recent-changes",

    // Fiche Configuree
    BEEM_SHOT_FICHE_CONFIGUREE: "/beem-shot/fiche-configuree",
    BEEM_SHOT_FICHE_CONFIGUREE_BY_OBJECT_ID: "/beem-shot/fiche-configuree/by-object-id",
    BEEM_SHOT_FICHE_CONFIGUREE_XML: "/beem-shot/fiche-configuree/xml",

    // UserController
    USER: "/user",
    USER_SEND_INVITATION: "/user/send-invitation",
    USER_WITH_ID: "/user/:userId",
    USER_ADMIN: "/user/admin/:userId",
    FORBIDDEN_DOMAIN_NAMES: "/user/forbidden-domain-names",
    DO_NOT_SHOW_FEATURES: "/user/do-not-show-features",

    //UtilsController
    UTILS: "/utils",
    UTILS_REVIT_PLUGIN: "/utils/revit-plugin",
    UTILS_EXPORT_USERS: "/utils/admin/export/users",
    UTILS_EXPORT_PROJECTS: "/utils/admin/export/projects",
    UTILS_EXPORT_BS_VARIANTS: "/utils/admin/export/bs-variants",
    UTILS_EXPORT_RSEE_DOCUMENTS: "/utils/admin/export/rsee-documents",
    UTILS_EXPORT_BS_BUILDINGS: "/utils/admin/export/bs-buildings",
    UTILS_EXPORT_BS_BIM_MODELS: "/utils/admin/export/bs-bim-models",
    UTILS_EXPORT_BS_INPUTS: "/utils/admin/export/bs-inputs",
    UTILS_EXPORT_BS_MATERIAL_RESULTS: "/utils/admin/export/bs-material-results",
    UTILS_ADMIN_DASHBOARD_ORGANIZATIONS: "/utils/admin/dashboard-organizations",
    UTILS_ADMIN_BS_DASHBOARD: "/utils/admin/bs-dashboard",
    UTILS_ADMIN_BP_DASHBOARD: "/utils/admin/bp-dashboard",
    UTILS_ADMIN_KAIRNIAL_DASHBOARD: "/utils/admin/kairnial-dashboard",
    UTILS_ADMIN_USAGE_DASHBOARD: "/utils/admin/usage-dashboard",

    //AdminJobsController
    UTILS_ADMIN_JOBS_SNOWFLAKE: "/utils/admin/jobs/snowflake",
    UTILS_ADMIN_JOBS_SNOWFLAKE_RUN: "/utils/admin/jobs/snowflake/run",
    UTILS_ADMIN_JOBS_KAIRNIAL: "/utils/admin/jobs/kairnial",
    UTILS_ADMIN_JOBS_INIES: "/utils/admin/jobs/inies",
    UTILS_ADMIN_JOBS_INIES_RUN: "/utils/admin/jobs/inies/run",
    UTILS_ADMIN_JOBS_COMENV: "/utils/admin/jobs/comenv",
    UTILS_ADMIN_JOBS_CERTIFICATION: "/utils/admin/jobs/certification",

    //AdminMaterialLibraryController (US 2526)
    UTILS_ADMIN_MATERIAL_LIBRARY_CATALOGUE: "/utils/admin/material-library/catalogue",
    UTILS_ADMIN_MATERIAL_LIBRARY_DRAFT: "/utils/admin/material-library/draft",
    UTILS_ADMIN_MATERIAL_LIBRARY_DRAFT_EXPORT: "/utils/admin/material-library/draft/export",
    UTILS_ADMIN_MATERIAL_LIBRARY_MACRO_DRAFT: "/utils/admin/material-library/macro-draft",
    UTILS_ADMIN_MATERIAL_LIBRARY_TYPE_DRAFT: "/utils/admin/material-library/type-draft",
    UTILS_ADMIN_MATERIAL_LIBRARY_STRUCTURE_DRAFT: "/utils/admin/material-library/structure-draft",

    //BeemShotController
    BEEM_SHOT: "/beem-shot",
    BEEM_SHOT_FICHE_CONFIGUREE_LIST: "/beem-shot/fiche-configuree/fiche-configuree-list",
    BEEM_SHOT_FICHE_CONFIGUREE_GAMME_LIST: "/beem-shot/fiche-configuree/fiche-configuree-gamme-list",
    BEEM_SHOT_FICHE_CONFIGUREE_GAMME: "/beem-shot/fiche-configuree/fiche-configuree-gamme",
    MACRO_MAKER: "/macro-maker",
    MACRO_MAKER_LIST: "/macro-maker/list",
    MACRO_MAKER_CATALOGUE: "/macro-maker/catalogue",
    MACRO_MAKER_OTHER_OPTIONS: "/macro-maker/other-options",
    MACRO_MAKER_FICHES_BY_NAME: "/macro-maker/fiches-by-name",
    MACRO_MAKER_SHARE: "/macro-maker/share",
    MACRO_MAKER_USAGES: "/macro-maker/usages",
    GAMME: "/gamme",
    GAMME_LIST: "/gamme/list",
    GAMME_TEAM: "/gamme/team",
    GAMME_FDES_AUDIT: "/gamme/fdes-audit",
    GAMME_REFERENTIEL: "/gamme/referentiel",
    BEEM_SHOT_MATERIAL_RESULT_LIST: "/beem-shot/material/material-result",
    BEEM_SHOT_MATERIAL_GAMME_FRAICHEUR: "/beem-shot/material/gamme-fraicheur",
    BEEM_SHOT_MATERIAL_REFRESH_GAMME: "/beem-shot/material/refresh-gamme",
    BEEM_SHOT_MATERIAL_GAMME_COEFFICIENT: "/beem-shot/material/gamme-coefficient",
    BEEM_SHOT_MATERIAL_RESET: "/beem-shot/material/reset",
    BEEM_SHOT_MATERIAL_ADD_OVERRIDDE: "/beem-shot/material/override-bsmaterial-result",
    BEEM_SHOT_MATERIAL_ROWS_REPLACED_ALONG: "/beem-shot/material/rows-replaced-along",
    BEEM_SHOT_INPUT: "/beem-shot/input",
    BEEM_SHOT_UPDATE_BUILDING_BS_ITEMS: "/beem-shot/bs-item/refresh-building-bs-items",
    BEEM_SHOT_REPARTITION_BS_ITEMS: "/beem-shot/bs-item/repartition-bs-items",
    BEEM_SHOT_GLOBAL_REPARTITION: "/beem-shot/bs-item/global-repartition",
    BEEM_SHOT_BIM_MODEL: "/beem-shot/bim-model",
    BEEM_SHOT_BIM_MODEL_CODE_EXTRAITS: "/beem-shot/bim-model/code-extraits",
    BEEM_SHOT_BIM_MODEL_EXCLUDED_CODE_EXTRAITS: "/beem-shot/bim-model/excluded-code-extraits",
    BEEM_SHOT_BIM_MODEL_ELEMENTS: "/beem-shot/bim-model/elements",
    // TEMPORARY — to remove on 11/01/2027 (US 2565), with the measures catch-up (measures-catch-up.ts).
    BEEM_SHOT_BIM_MODEL_ELEMENT_MEASURES: "/beem-shot/bim-model/elements/measures",
    BEEM_SHOT_BIM_FILE: "/beem-shot/bim-model/file",
    BEEM_SHOT_BIM_FRAG: "/beem-shot/bim-model/frag",
    BEEM_SHOT_ALL_BIM_MODEL_ID: "/beem-shot/bim-model/all-bs-bim-model",
    BEEM_SHOT_BIM_MODEL_BUILDING: "/beem-shot/bim-model/building",
    BEEM_SHOT_BIM_MODEL_BUILDING_ALL: "/beem-shot/bim-model/building/all",
    BEEM_SHOT_BIM_MODEL_BUILDING_CODE_EXTRAITS: "/beem-shot/bim-model/building/code-extraits",
    BEEM_SHOT_VARIANT_BY_BIM_MODEL: "/beem-shot/bim-model/variants-by-bim-model-id",
    BEEM_SHOT_AVA_FEEDBACK: "/beem-shot/ava/feedback",
    BEEM_SHOT_AVA_ERROR: "/beem-shot/ava/error",
    BEEM_SHOT_ITEM: "/beem-shot/bs-item",
    BEEM_SHOT_SAME_ITEM_UPDATE_QUANTITY: "/beem-shot/bs-item/extracted-quantities",
    BEEM_SHOT_ADD_MATERIAL: "/beem-shot/material/add-custom-material",
    BEEM_SHOT_DELETE_MATERIAL: "/beem-shot/material",
    BEEM_SHOT_CATEGORIES: "/beem-shot/categories",
    BEEM_SHOT_MACRO_COMPONENT_TYPE: "/beem-shot/bs-item/bs-macro-component-type",
    BEEM_SHOT_MACRO_COMPONENT_OPTIONS: "/beem-shot/bs-item/bs-macro-components-options",
    BEEM_SHOT_ITEM_GAMME_PRODUITS: "/beem-shot/bs-item/gamme-produits",
    BEEM_SHOT_ITEM_RESET_MATERIALITY: "/beem-shot/bs-item/:bsItemId/reset-materiality",
    BEEM_SHOT_ITEM_MATERIALITY_COPY_TARGETS: "/beem-shot/bs-item/:bsItemId/materiality-copy-targets",
    BEEM_SHOT_ITEM_COPY_MATERIALITY: "/beem-shot/bs-item/:bsItemId/copy-materiality",
    // US 2566 — the items whose same list can take the impact type the list has on the item, and giving it to them
    BEEM_SHOT_ITEM_SAME_LIST_ITEMS: "/beem-shot/bs-item/:bsItemId/same-list-items",
    BEEM_SHOT_ITEM_GIVE_LIST_IMPACT_TYPE: "/beem-shot/bs-item/:bsItemId/give-list-impact-type",
    // US 2566 — the carbon of the item with each macro of the library of Time To Beem it can take
    BEEM_SHOT_ITEM_CARBON_OF_CHOICES: "/beem-shot/bs-item/:bsItemId/carbon-of-choices",
    // US 2549 — the items the user adds in the advanced questionnaire
    BEEM_SHOT_CUSTOM_ITEM: "/beem-shot/custom-item",
    BEEM_SHOT_CUSTOM_ITEM_TYPES: "/beem-shot/custom-item/types",
    BEEM_SHOT_MATERIAL_RESULT_DISABLE: "/beem-shot/material/enable",
    // Quanti documents (US 2886)
    QUANTI_DOCUMENT: "/quanti/document",
    QUANTI_DOCUMENT_LIST: "/quanti/document/document-list",
    QUANTI_DOCUMENT_FILE: "/quanti/document/:quantiDocumentId/file",
    QUANTI_DOCUMENT_CALIBRATE: "/quanti/document/calibrate",
    QUANTI_DOCUMENT_RENAME: "/quanti/document/rename",
    QUANTI_DOCUMENT_DELETE: "/quanti/document/:quantiDocumentId",
    // Quanti variants (US 2886)
    QUANTI_VARIANT: "/quanti/variant",
    QUANTI_VARIANT_LIST: "/quanti/variant/variant-list",
    QUANTI_VARIANT_BY_ID: "/quanti/variant/:quantiVariantId",
    QUANTI_VARIANT_PATCH: "/quanti/variant/patch-variant",
    QUANTI_VARIANT_PARCELLE_DOCUMENT: "/quanti/variant/parcelle-document",
    QUANTI_VARIANT_PARCELLE_ELEMENTS: "/quanti/variant/parcelle-elements",
    QUANTI_VARIANT_EARTHWORK: "/quanti/variant/earthwork",
    QUANTI_VARIANT_TERRAIN: "/quanti/variant/terrain",
    QUANTI_VARIANT_TERRAIN_LOOKUP: "/quanti/variant/terrain-lookup",
    QUANTI_VARIANT_TERRAIN_RELIEF: "/quanti/variant/terrain-relief",
    QUANTI_VARIANT_OPERATION_LEVELS: "/quanti/variant/operation-levels",
    QUANTI_VARIANT_OPERATION_FACADES: "/quanti/variant/operation-facades",
    QUANTI_VARIANT_OPERATION_COUPES: "/quanti/variant/operation-coupes",
    QUANTI_VARIANT_SHEET_PLACEMENTS: "/quanti/variant/sheet-placements",
    QUANTI_VARIANT_BUILDING_COMMON_WALLS: "/quanti/variant/building-common-walls",
    QUANTI_VARIANT_DELETE: "/quanti/variant/delete/:quantiVariantId",
    // Quanti buildings (US 2886)
    QUANTI_BUILDING: "/quanti/building",
    QUANTI_BUILDING_LIST: "/quanti/building/building-list",
    QUANTI_BUILDING_RENAME: "/quanti/building/rename",
    QUANTI_BUILDING_ALTIMETRY: "/quanti/building/altimetry",
    QUANTI_BUILDING_FOOTPRINT: "/quanti/building/footprint",
    QUANTI_BUILDING_ANNEX: "/quanti/building/annex",
    QUANTI_BUILDING_EARTHWORK: "/quanti/building/earthwork",
    QUANTI_BUILDING_MORPHOLOGY: "/quanti/building/morphology",
    QUANTI_BUILDING_DELETE: "/quanti/building/delete/:quantiBuildingId",
    // Quanti reference data (US 2886) — Beem Shot's wall lists, constants of the application
    QUANTI_REFERENCE_WALL_LIBRARIES: "/quanti/reference/wall-libraries",
    // DPGF to Carbon (US 2597)
    // GRETA (US 2532)
    GRETA_AUDIT: "/greta/audit",
    GRETA_AUDIT_LIST: "/greta/audit/audit-list",
    GRETA_AUDIT_BY_ID: "/greta/audit/:gretaAuditId",
    GRETA_AUDIT_LINE_LIST: "/greta/audit/:gretaAuditId/line-list",
    GRETA_AUDIT_PRESCRIPTION_FILE: "/greta/audit/:gretaAuditId/prescription-file",
    GRETA_AUDIT_CCTP: "/greta/audit/:gretaAuditId/cctp",
    GRETA_AUDIT_CCTP_LIST: "/greta/audit/:gretaAuditId/cctp-list",
    GRETA_CCTP_BY_ID: "/greta/audit/cctp/:gretaAuditCctpId",
    GRETA_CCTP_FILE: "/greta/audit/cctp/:gretaAuditCctpId/file",
    GRETA_AUDIT_RUN: "/greta/audit/:gretaAuditId/run",
    GRETA_AUDIT_CSV: "/greta/audit/:gretaAuditId/csv",
    GRETA_AUDIT_LINE: "/greta/audit/line",

    DPGF_IMPORT: "/dpgf/import",
    DPGF_IMPORT_LIST: "/dpgf/import/import-list",
    DPGF_IMPORT_PAIRING: "/dpgf/import/pairing",
    DPGF_IMPORT_BY_ID: "/dpgf/import/:dpgfImportId",
    DPGF_IMPORT_CLASSIFY: "/dpgf/import/:dpgfImportId/classify",
    DPGF_IMPORT_LINE_LIST: "/dpgf/import/:dpgfImportId/line-list",
    DPGF_IMPORT_LINE_PATCH: "/dpgf/import/line",
    // DPGF to Carbon — CCTP and INIES fiches (US 2597, J4)
    DPGF_IMPORT_CCTP: "/dpgf/import/:dpgfImportId/cctp",
    DPGF_IMPORT_CCTP_LIST: "/dpgf/import/:dpgfImportId/cctp-list",
    DPGF_CCTP_DELETE: "/dpgf/import/cctp/:dpgfCctpId",
    DPGF_IMPORT_FIND_FICHES: "/dpgf/import/:dpgfImportId/find-fiches",
    DPGF_IMPORT_PRODUCT_LIST: "/dpgf/import/:dpgfImportId/product-list",
    DPGF_PRODUCT_PATCH: "/dpgf/import/product",
    DPGF_IMPORT_FILE: "/dpgf/import/:dpgfImportId/file",
    DPGF_IMPORT_DELETE: "/dpgf/import/:dpgfImportId",
    // DPGF to Carbon — the carbon calculation of the project by Comenv (US 2597)
    DPGF_CARBON_CALCULATION: "/dpgf/carbon-calculation",
    DPGF_CARBON_CALCULATION_CALCULATE: "/dpgf/carbon-calculation/calculate",
    DPGF_CARBON_CALCULATION_RESULT: "/dpgf/carbon-calculation/result",
    // Beem shot estimations/variants
    BEEM_SHOT_VARIANT: "/beem-shot/variant",
    BEEM_SHOT_VARIANT_FROM_RSEE: "/beem-shot/variant/from-rsee",
    BEEM_SHOT_VARIANT_RETRY_INIT: "/beem-shot/variant/retry-init/:variantId",
    BEEM_SHOT_VARIANT_CREATE_CERTIFICATION: "/beem-shot/variant/create-certification",
    BEEM_SHOT_ALL_VARIANT: "/beem-shot/variant/variant-list",
    BEEM_SHOT_VARIANT_READY: "/beem-shot/variant/variant-list-ready",
    BEEM_SHOT_VARIANT_PATCH: "/beem-shot/variant/patch-bs-variant",
    BEEM_SHOT_VARIANT_PATCH_PLUVIOMETRIE: "/beem-shot/variant/patch-pluviometrie",
    BEEM_SHOT_VARIANT_LIBRARY_VERSION_CHECK: "/beem-shot/variant/:variantId/library-version/check",
    BEEM_SHOT_VARIANT_LIBRARY_VERSION: "/beem-shot/variant/:variantId/library-version",
    BEEM_SHOT_VARIANT_LIBRARY_VERSION_CHANGES: "/beem-shot/variant/:variantId/library-version/changes",
    BEEM_SHOT_VARIANT_LIBRARY_VERSION_RELEASE_NOTE: "/beem-shot/variant/:variantId/library-version/release-note",
    BEEM_SHOT_VARIANT_LINK_BIM_MODEL_TO_BUILDING: "/beem-shot/building/link-bs-bim-model",
    BEEM_SHOT_VARIANT_DELETE: "/beem-shot/variant/delete/:bsVariantId",
    BEEM_SHOT_BUILDING_CODE_EXTRAIT_LIST: "/beem-shot/building/code-extrait/list",
    BEEM_SHOT_VARIANT_BUILDING_LIST: "/beem-shot/building/list",

    // Beem shot buildings
    BEEM_SHOT_BUILDING: "/beem-shot/building",
    BEEM_SHOT_BUILDING_PUT_FOUNDATION: "/beem-shot/building/put-bs-building-foundation",
    BEEM_SHOT_BUILDING_UPDATE_INFOS: "/beem-shot/building/update-name-and-description",
    BEEM_SHOT_BUILDING_PUT_LEVEL_AND_ZONE: "/beem-shot/building/put-bs-input-level-and-zone",
    BEEM_SHOT_BUILDING_START_ESTIMATE: "/beem-shot/building/bsBuildingId/:bsBuildingId/start-estimating",
    BEEM_SHOT_BUILDING_VALIDATE_REPARTITION: "/beem-shot/building/validate-repartition",
    BEEM_SHOT_BUILDING_CURTAIN_WALLS: "/beem-shot/building/curtain-walls",
    BEEM_SHOT_BUILDING_EMPRISE_AU_SOL_OVERRIDE: "/beem-shot/building/emprise-au-sol-override",

    // Beem shot parcelle
    BEEM_SHOT_PARCELLE_GET: "/beem-shot/parcelle/get-bs-parcelle/:bsVariantId",
    BEEM_SHOT_PARCELLE_PUT: "/beem-shot/parcelle/put-bs-parcelle",

    // Beem shot parcelle component
    BEEM_SHOT_PARCELLE_COMPONENT_LIST: "/beem-shot/parcelle-component/list/:bsVariantId",
    BEEM_SHOT_PARCELLE_COMPONENT_ADD: "/beem-shot/parcelle-component/add",
    BEEM_SHOT_PARCELLE_COMPONENT_UPDATE: "/beem-shot/parcelle-component/:id",
    BEEM_SHOT_PARCELLE_COMPONENT_DELETE: "/beem-shot/parcelle-component/:id",

    // Beem shot energie
    BEEM_SHOT_ENERGIE_UPLOAD: "/beem-shot/energie/upload/:bsVariantId",
    BEEM_SHOT_ENERGIE_GET: "/beem-shot/energie/get/:bsVariantId",
    BEEM_SHOT_ENERGIE_SAVE_MATCHING: "/beem-shot/energie/save-matching",
    BEEM_SHOT_ENERGIE_SAVE_MISSING_FIELD: "/beem-shot/energie/save-missing-field",
    BEEM_SHOT_ENERGIE_SAVE_RESEAU_CHALEUR: "/beem-shot/energie/save-reseau-chaleur",
    BEEM_SHOT_ENERGIE_DELETE: "/beem-shot/energie/delete/:bsVariantId",
    BEEM_SHOT_ENERGIE_RESEAU_CHALEUR_FROID: "/beem-shot/energie/reseau-chaleur-froid",
    BEEM_SHOT_ENERGIE_MORPHO_SURFACE_REFS: "/beem-shot/energie/morpho-surface-refs/:bsVariantId",

    // Beem shot chantier component
    BEEM_SHOT_CHANTIER_COMPONENT_LIST: "/beem-shot/chantier-component/list/:bsZoneId",
    BEEM_SHOT_CHANTIER_COMPONENT_ADD: "/beem-shot/chantier-component/add",
    BEEM_SHOT_CHANTIER_COMPONENT_UPDATE: "/beem-shot/chantier-component/:id",
    BEEM_SHOT_CHANTIER_COMPONENT_DELETE: "/beem-shot/chantier-component/:id",

    // Beem shot zone chantier
    BEEM_SHOT_ZONE_CHANTIER: "/beem-shot/chantier/get-bs-zone-chantier/:bsZoneId",
    BEEM_SHOT_ZONE_PUT_CHANTIER: "/beem-shot/chantier/put-bs-zone-chantier",
    BEEM_SHOT_ZONE_DEFAULT_CHANTIER: "/beem-shot/chantier/get-default-chantier/:bsZoneId",
    BEEM_SHOT_ZONE_DEFAULT_TERRES_EXCAVEES: "/beem-shot/chantier/get-default-terres-excavees/:bsZoneId",

    // Beem shot zone eau
    BEEM_SHOT_ZONE_EAU: "/beem-shot/eau/get-bs-zone-eau/:bsZoneId",
    BEEM_SHOT_ZONE_PUT_EAU: "/beem-shot/eau/put-bs-zone-eau",
    BEEM_SHOT_ZONE_DEFAULT_EAU: "/beem-shot/eau/get-default-eau/:bsZoneId",

    // Beem shot buildings morphology
    BEEM_SHOT_BUILDING_MORPHOLOGY_PLAN: "/beem-shot/building/morphology/plan",
    BEEM_SHOT_BUILDING_MORPHOLOGY_PLAN_IMAGE: "/beem-shot/building/morphology/plan/image",
    BEEM_SHOT_BUILDING_MORPHOLOGY_PLAN_SOURCE: "/beem-shot/building/morphology/plan/source",
    BEEM_SHOT_BUILDING_MORPHOLOGY_PLAN_COPY: "/beem-shot/building/morphology/plan/copy",
    BEEM_SHOT_BUILDING_MORPHOLOGY_PLAN_OUTLINE: "/beem-shot/building/morphology/plan/outline",
    BEEM_SHOT_BUILDING_MORPHOLOGY_PLAN_ANCHOR: "/beem-shot/building/morphology/plan/anchor",
    BEEM_SHOT_BUILDING_MORPHOLOGY_PLAN_AI_READING: "/beem-shot/building/morphology/plan/ai-reading",

    // Beem shot buildings parkings
    BEEM_SHOT_PARKING: "/beem-shot/parking",
    BEEM_SHOT_PARKING_LIST: "/beem-shot/parking/list",
    BEEM_SHOT_BIM_PARKING: "/beem-shot/parking/bim",

    // BSZoneController
    BEEM_SHOT_ZONE: "/beem-shot/zone",
    BEEM_SHOT_ZONE_ALL: "/beem-shot/zone/list",
    BEEM_SHOT_ZONE_RESET_SURFACE: "/beem-shot/zone/reset-surface",
    BEEM_SHOT_ZONE_RESET_OCCUPANTS: "/beem-shot/zone/reset-occupants",

    BEEM_SHOT_BUILDING_CREATE_BS_ITEMS: "/beem-shot/building/create-bs-items-morphology",

    // Beem shot buildings level
    BEEM_SHOT_BUILDING_LEVEL_LIST: "/beem-shot/level/level-list",
    BEEM_SHOT_BUILDING_LEVEL_LIST_BY_VARIANT: "/beem-shot/level/level-list-by-variant",
    // US 2405 (Rivaton I) — exposed terrasse-en-épannelage area per level group
    BEEM_SHOT_TERRASSES_EPANNELAGE: "/beem-shot/level/terrasses-epannelage",

    // Beem shot buildings patios
    BEEM_SHOT_PATIOS_LIST: "/beem-shot/patio/patio-list",
    BEEM_SHOT_PATIOS_LIST_BY_VARIANT: "/beem-shot/patio/patio-list-by-variant",
    BEEM_SHOT_PATIO: "/beem-shot/patio",

    // BimModelController
    TUTORIAL_SIGNED_URL_VIDEO: "/tutorial/signed-url/video",
    TUTORIAL_SIGNED_URL_THUMBNAIL: "/tutorial/signed-url/thumbnail",
    TUTORIAL_FILE: "/tutorial/tutorial-file",
    // Tutorial videos uploaded by the Time To Beem team (US 2403)
    TUTORIAL_VIDEOS: "/tutorial/videos",
    TUTORIAL_VIDEOS_SIGNED_URL: "/tutorial/videos/signed-url",

    // Karnial
    KAIRNIAL_PROJECT: "/kairnial/kairnial-project",
    KAIRNIAL_OPEE_MEAN_IC_CONSTRUCTION_BY_USAGE: "/kairnial/opee/mean-ic-construction-by-usage",
    KAIRNIAL_OPEE_LOT_IMPACTS_BY_USAGE: "/kairnial/opee/lot-impacts-by-usage",
    KAIRNIAL_RSEE_IMPORT_LOG_LIST: "/kairnial/rsee-import-log/rsee-import-log-list-public",
    KAIRNIAL_RSEE_CONTROL_REPORT: "/kairnial/rsee-control-report-public",
    KAIRNIAL_PROJECT_LIST: "/kairnial/kairnial-project-list",
    KAIRNIAL_DOCUMENT_LIST: "/kairnial/kairnial-document-list",
    KAIRNIAL_RSEE_DOCUMENT_LIST: "/kairnial/kairnial-rsee-document-list",
    KAIRNIAL_SYNCHRONIZE_PROJECT: "/kairnial/synchronize-project",
    KAIRNIAL_SYNCHRONIZATION: "/kairnial/synchronization-kairnial",
    KAIRNIAL_GLOBAL_REPORTING_DATA: "/kairnial/global-reporting-data",
    KAIRNIAL_PILOT_COMENV_RESULT: "/kairnial/pilot/result-public",
    KAIRNIAL_PILOT_COMENV_STATUS: "/kairnial/pilot/status-public",
    KAIRNIAL_PILOT_COMENV_BASELINE: "/kairnial/pilot/baseline-public",
    KAIRNIAL_RSEE_RESULT_LIST: "/kairnial/rsee-result/rsee-result-list-public",
    KAIRNIAL_RSEE_INPUT_LIST: "/kairnial/rsee-input/rsee-input-list-public",
    KAIRNIAL_RSEE_RSET_OUTPUT_LIST: "/kairnial/rsee-rset-output/rsee-rset-output-list-public",
    KAIRNIAL_RSEE_CEP_ANNUAL_LIST: "/kairnial/rsee-cep-annual/rsee-cep-annual-list-public",
    KAIRNIAL_RSEE_BE_LIST: "/kairnial/rsee-be/rsee-be-list-public",
    KAIRNIAL_RSEE_LOGICIEL_LIST: "/kairnial/rsee-logiciel/rsee-logiciel-list-public",
    KAIRNIAL_RSEE_OUTPUT_LIST: "/kairnial/rsee-output/rsee-output-list-public",
    KAIRNIAL_RSEE_RSET_PAROI_VITREE_LIST: "/kairnial/rsee-rset-paroi-vitree/rsee-rset-paroi-vitree-list-public",
    KAIRNIAL_COMPANY_BRANCH: "/kairnial/company-branch",

    // Kairnial Customization
    KAIRNIAL_CUSTOMIZATION_OVERRIDE_INPUT: "/kairnial/customization/override-input",
    KAIRNIAL_CUSTOMIZATION_OVERRIDE_INPUT_TOGGLE: "/kairnial/customization/override-input/toggle-enabled",
    KAIRNIAL_CUSTOMIZATION_OVERRIDE_INPUT_LIST: "/kairnial/customization/override-input-list",
    KAIRNIAL_CUSTOMIZATION_CUSTOM_INPUT: "/kairnial/customization/custom-input",
    KAIRNIAL_CUSTOMIZATION_CUSTOM_INPUT_LIST: "/kairnial/customization/custom-input-list",

    // Kairnial Material Lib
    KAIRNIAL_MATERIAL_LIB_DECLARATION_TYPES: "/kairnial/material-lib/declaration-types",
    KAIRNIAL_MATERIAL_LIB_NOMENCLATURE_FILTERS: "/kairnial/material-lib/get-nomenclature-filters",
    KAIRNIAL_MATERIAL_LIB_RECORDS_FILTERED_PAGINATED: "/kairnial/material-lib/inies-records-filtered-paginated",
    KAIRNIAL_MATERIAL_LIB_ORGANISM_LIST: "/kairnial/material-lib/organism-list",
    KAIRNIAL_MATERIAL_LIB_RECORD: "/kairnial/material-lib/record",
    KAIRNIAL_MATERIAL_LIB_FICHE_CONFIGUREE: "/kairnial/material-lib/fiche-configuree",
    KAIRNIAL_MATERIAL_LIB_FICHE_CONFIGUREE_BY_OBJECT_ID: "/kairnial/material-lib/fiche-configuree/by-object-id",
    KAIRNIAL_MATERIAL_LIB_FICHE_CONFIGUREE_LIST: "/kairnial/material-lib/fiche-configuree/fiche-configuree-list",

    // CertificationController
    CERTIFICATION_GENERATE_RSEE: "/beem-shot/certification/generate-rsee",
    CERTIFICATION_RSEE_STATUS: "/beem-shot/certification/rsee-status",
    CERTIFICATION_RSEE_DOWNLOAD: "/beem-shot/certification/rsee-download",
    CERTIFICATION_ENV_REPORT: "/beem-shot/certification/report/environnement",
    CERTIFICATION_CALCULATE: "/beem-shot/certification/calculate",
    CERTIFICATION_CALCULATE_STATUS: "/beem-shot/certification/calculation-status",
    CERTIFICATION_GET_BUILDING_RESULT: "/beem-shot/certification/certification-result",
    CERTIFICATION_GET_PARCELLE_RESULT: "/beem-shot/certification/parcelle-result",
    CERTIFICATION_GET_PROJET_INDICATORS: "/beem-shot/certification/projet-indicators",
    CERTIFICATION_GET_PROJET_INFO: "/beem-shot/certification/projet-info",
    CERTIFICATION_VARIANT_FICHES_XML: "/beem-shot/certification/variant-fiches-configurees-xml",
    CERTIFICATION_FDES_UPDATES: "/beem-shot/certification/fdes-updates",
    CERTIFICATION_FDES_UPDATE_ALL: "/beem-shot/certification/fdes-updates/update-all",
    CERTIFICATION_FDES_KEEP: "/beem-shot/certification/fdes-updates/keep",
    CERTIFICATION_FDES_UPDATE: "/beem-shot/certification/fdes-updates/update",
    CERTIFICATION_FDES_REPLACE: "/beem-shot/certification/fdes-updates/replace",

    // BSEstimationComenvController (US 2200 — Comenv-powered estimation pipeline)
    ESTIMATION_COMENV_CALCULATE: "/beem-shot/comenv/calculate",
    ESTIMATION_COMENV_REQUEST_UPDATE: "/beem-shot/comenv/request-update",
    ESTIMATION_COMENV_GET_RESULT: "/beem-shot/comenv/result",
    ESTIMATION_COMENV_CALCUL_STATUS: "/beem-shot/comenv/calcul-status",

    // Mlab
    MLAB_DEMANDEUR: "/mlab/demandeur",
    MLAB_SUBMIT_EMPTY_COMPONENT: "/mlab/submit-empty-component",
    MLAB_DEMANDES: "/mlab/demandes",

    // BI controller
    BI_BIOSOURCE_THRESHOLD: "/bi/biosource-threshold",
    BI_BIOSOURCE_THRESHOLD_LIST: "/bi/biosource-threshold-list",
  },

  regex: {
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    onlyDigits: /\d+/,
    notDigits: /\D+/,
    phone: /^\+\d{9,11}$/,
    passwordContainsLowerCase: /.*[a-z].*/,
    passwordContainsUpperCase: /.*[A-Z].*/,
    passwordContainsSpecialChar: /.*[\^$*.[\]()?\-"!@#%&/\\,><':;|_~`+=].*/,
    number: /\d*[,.]?\d*/,
    zipCode: /^((0[1-9])|([1-8][0-9])|(9[0-8])|(2A)|(2B))[0-9]{3}$/,
    ifcUnicodeRegEx: /\\X2\\(.*?)\\X0\\/giu,
    ifcUnicodeAccentMatcherRegEx: /\\X\\([0-9A-Fa-f]{2})/g,
    ifcUnicodeAccentReplacerRegEx: /\\x([0-9a-f]{2})/gi,
  },

  // localStorageKey
  localStorage: {
    USER: "user",
  },

  miscellaneous: {
    DRAWER_WIDTH: 240,
    PROJECT_IMG_WIDTH: 270,
    PROJECT_IMG_HEIGTH: 270,
    PROJECT_IMG_MAX_WIDTH: 1080,
    PROJECT_IMG_MAX_HEIGTH: 1080,
    PROJECT_IMG_MAX_SIZE: 3, // MB
    PROJECT_NAME_MAX_LENGTH: 256, // Must match the @Size constraint on the backend project DTOs
    LABEL_UNLIMITED: "Illimité",
  },

  /** Cache API keys */
  cacheApi: {
    /** The browser store of the maquette files, no longer written nor read (US 2545): kept only so it can be deleted. */
    IFC_CACH: "ifcCach-v2",
    /** The pre-US-2441 store, kept only so it can be deleted. */
    IFC_CACH_LEGACY: "ifcCach",
    /** caching key for the fullscreen in new tab feature */
    FULLSCREEN_CACH: "fullScreenCach",
  },

  contact: {
    mail: "contact@timetobeem.com",
    phone: "+33 7 61 89 58 03",
  },

  web: {
    baseInie: "https://www.base-inies.fr/iniesV4/dist/consultation.html",
  },

  utils: {
    space: " ",
  },
}
